import { render, staticRenderFns } from "./DynamicCheckbox.vue?vue&type=template&id=7a89c08b&scoped=true"
import script from "./DynamicCheckbox.vue?vue&type=script&lang=js"
export * from "./DynamicCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a89c08b",
  null
  
)

export default component.exports